const ADMIN_LIKE_ROLES = ['admin', 'administrator', 'super admin', 'superadmin', 'cso', 'ceo', 'principal consultant'];
const MANAGER_ROLES = ['asm / senior sm / sm', 'associate director (pl owner)'];
const SALES_EXEC_ROLES = ['sales fos'];

export const getRoleName = (user) => {
  if (!user) return '';
  if (user?.role === null || user?.role === undefined) return 'admin';
  if (user.role && typeof user.role === 'object') return String(user.role.name || user.role.label || '').trim().toLowerCase();
  if (user.role_name) return String(user.role_name).trim().toLowerCase();
  if (typeof user.role === 'string') return user.role.trim().toLowerCase();
  if (user.designation) return String(user.designation).trim().toLowerCase();
  if (user.is_superuser === true || user.is_staff === true) return 'admin';
  return '';
};

export const isAdminLike = (user) => {
  const roleName = getRoleName(user);
  return ADMIN_LIKE_ROLES.includes(roleName) || user?.is_superuser === true || user?.is_staff === true;
};

export const isTrueAdmin = (user) => (
  user?.role === null ||
  user?.role === undefined ||
  user?.is_superuser === true ||
  user?.is_staff === true
);

export const isManagerLike = (user) => MANAGER_ROLES.includes(getRoleName(user));

export const isSalesExecutive = (user) => SALES_EXEC_ROLES.includes(getRoleName(user));

export const canAccessReports = (user, hasPermission) => {
  if (!user) return false;
  if (isAdminLike(user) || isManagerLike(user) || isSalesExecutive(user)) return true;
  return typeof hasPermission === 'function'
    ? hasPermission('report_read') || hasPermission('lead_read')
    : false;
};

export const getReportScopeUsers = (currentUser, allUsers = []) => {
  if (!currentUser?.id) return [];
  if (isAdminLike(currentUser)) return allUsers;

  const currentId = String(currentUser.id);
  if (isSalesExecutive(currentUser)) {
    return allUsers.filter((user) => String(user.id) === currentId);
  }

  if (isManagerLike(currentUser)) {
    return allUsers.filter((user) => {
      const userId = String(user.id);
      const managerId = String(user.reporting_manager?.id ?? user.reporting_manager ?? user.reporting_manager_id ?? '');
      return userId === currentId || managerId === currentId;
    });
  }

  return allUsers.filter((user) => String(user.id) === currentId);
};

export const getReportScopeUserIds = (scopeUsers = []) => (
  scopeUsers.map((user) => String(user.id)).filter(Boolean)
);

export const getUserFullName = (user) => (
  [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.email || ''
);

export const getScopeUserNames = (scopeUsers = []) => (
  scopeUsers
    .map((user) => getUserFullName(user).trim().toLowerCase())
    .filter(Boolean)
);

export const matchesScopeByName = (value, scopeUsers = []) => {
  const candidate = String(value || '').trim().toLowerCase();
  if (!candidate) return false;
  return getScopeUserNames(scopeUsers).some((name) => candidate.includes(name));
};

export const canAccessFinanceAdminScreens = (user, hasPermission, permissionCode = null) => {
  if (!isAdminLike(user)) return false;
  if (isTrueAdmin(user)) {
    return true;
  }
  if (!permissionCode) return true;

  return typeof hasPermission === 'function'
    ? hasPermission(permissionCode, user)
    : false;
};

export const canAccessLeadRecord = (lead, currentUser, scopeUserIds = []) => {
  if (!lead || !currentUser) return false;
  if (isAdminLike(currentUser)) return true;

  const candidateIds = [
    lead.created_by_detail?.id,
    lead.created_by,
    lead.internal_staff?.id,
    lead.internal_staff_id,
  ]
    .map((value) => String(value || ''))
    .filter(Boolean);

  return candidateIds.some((value) => scopeUserIds.includes(value));
};
